import React from 'react'
import Header from "../../../../Components/Header";
import Supplier from './Supplier'
import { Helmet } from 'react-helmet';
function CreateSupplier() {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Supplier Group - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <Supplier />
      </div>
    </div>
  )
}

export default CreateSupplier
